export const SponsorsSection = () => {

   return (
      <div>
         <section id="sponsors" className="container" style={{ padding: window.innerWidth > 900 && "2rem" }}>
            <div className="row">
               <div className="section-header col">
                  <h2 className="text-center title mt-5">SPONSORS</h2>
                  <hr className="lines" />
               </div>
            </div>


            <div className="row text-center" style={{ justifyContent: "center" }}>
               <div
                  className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
                  style={{
                     backgroundColor: "#3F6BFE !important",
                     borderRadius: "10px",
                  }}
               >
                  <h4>Diamond Sponsors</h4>
               </div>

               <a rel='noreferrer' href="https://www.brownrudnick.com" target="_blank" style={{ marginTop: '40px', marginBottom: '40px' }}>
                  <img
                     className="lazy"
                     loading="lazy"
                     src="./assets/media/brown_rudnick.webp"
                     alt=""
                     width="275px"
                  />
               </a>
               <a rel='noreferrer' href="https://palladiumcapital.com/" target="_blank" style={{ marginTop: '40px', marginBottom: '40px' }}>
                  <img
                     className="lazy"
                     loading="lazy"
                     src="./assets/media/Palladium Capital.png"
                     alt=""
                     width="275px"
                  />
               </a>

            </div>

            <div className="row text-center" style={{ justifyContent: "center" }}>
               <div
                  className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
                  style={{
                     backgroundColor: "#3F6BFE !important",
                     borderRadius: "10px",
                  }}
               >
                  <h4>Platinum Sponsors</h4>
               </div>

               <a href="sponsor-link" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     src="./assets/events/vsvc21/sponsors/McDermott-Will-Emery-LLP_2021.png"
                     alt=""
                  />
               </a>
            </div>

            {/* <div className="row text-center" style={{ justifyContent: "center" }}>
          <div
            className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
            style={{
              backgroundColor: "#3F6BFE !important",
              borderRadius: "10px",
            }}
          >
            <h4>Coaching Sponsors</h4>
          </div>
          <a href="sponsor-link" target="_blank">
            <img
              className="lazy"
              loading="lazy"
              src="./assets/events/vsvc21/sponsors/Troutman-Pepper-LLP.jpeg"
              alt=""
            />
          </a>
        </div> */}
            {/* 
        <div className="row text-center" style={{ justifyContent: "center" }}>
          <div
            className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
            style={{
              backgroundColor: "#3F6BFE !important",
              borderRadius: "10px",
            }}
          >
            <h4>Europe Partner</h4>
          </div>
          <a href="sponsor-link" target="_blank">
            <img
              className="lazy"
              loading="lazy"
              src="./assets/events/vsvc21/sponsors/Invest-in-Bavaria_2019.png"
              alt=""
            />
          </a>
        </div> */}

            <div className="row text-center" style={{ justifyContent: "center", alignItems: 'center' }}>
               <div
                  className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
                  style={{
                     backgroundColor: "#3F6BFE !important",
                     borderRadius: "10px",
                  }}
               >
                  <h4>Gold Sponsors</h4>
               </div>
               <a rel='noreferrer' href="https://www.agencyip.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/media/logo.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://boardsi.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/media/boardsi.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://www.cartika.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     src="./assets/events/vsvc21/sponsors/Cartika-250x134.png"
                     alt=""
                  />
               </a>

               <a rel='noreferrer' href="https://innovationcenter.tech/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/events/vsvc21/sponsors/IC-logo-2.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://www.jetro.go.jp/en/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/media/jetro_logo.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://mongotel.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/events/vsvc21/sponsors/mongotel-e1638444035285.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://www.linkedin.com/in/mfalato/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/events/vsvc21/sponsors/fullthrottlefalatoleads.jpeg"
                     alt=""
                  />
               </a>



               <a rel='noreferrer' href="https://salesqualia.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/media/Group 109 (1).png"
                     alt=""
                  />
               </a>

               <a rel='noreferrer' href="https://www.shrwood.com/" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     width="200px"
                     src="./assets/media/Sherwood Black 1.png"
                     alt=""
                  />
               </a>

            </div>

            <div className="row text-center" style={{ justifyContent: "center", alignItems: 'center' }}>
               <div
                  className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
                  style={{
                     backgroundColor: "#3F6BFE !important",
                     borderRadius: "10px",
                  }}
               >
                  <h4>Venture Sponsors</h4>
               </div>
               <a rel='noreferrer' href="https://www.allstate.com/strategic-ventures/main.htm" target="_blank">
                  <img
                     className="lazy"
                     loading="lazy"
                     src="./assets/media/Allstate-Strategic-Ventures.png"
                     style={{ maxWidth: "175px" }}
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://www.energyfoundry.com/" target="_blank">
                  <img
                     className="lazy"
                     style={{ marginTop: "15px", marginBottom: "15px", maxWidth: '175px' }}
                     loading="lazy"
                     src="./assets/events/vsvc21/sponsors/bcda75fe6b78252432383bf72adc0c1b-1-250x88.png"
                     alt=""
                  />
               </a>
               <a rel='noreferrer' href="https://masaimpact.com/" target="_blank">
                  <img
                     className="lazy"
                     style={{ marginTop: "15px", marginBottom: "15px", maxWidth: '175px' }}
                     loading="lazy"
                     src="./assets/media/masa_partners.jpg"
                     alt=""
                  />
               </a>


            </div>

            <div className="row text-center" style={{ justifyContent: "center" }}>
               <div
                  className="col-md-12 text-center p-1 mb-0   text-white theme-bg-primary"
                  style={{
                     backgroundColor: "#3F6BFE !important",
                     borderRadius: "10px",
                  }}
               >
                  <h4>Industry Partners</h4>
               </div>
               <div className="industry-container" style={{ display: 'flex', justifyContent: 'center' }}>
                  {/* <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Georgia-Bio.png"
                alt=""
              />
            </a> */}
                  <a
                     href="sponsor-link"
                     style={{ height: "fit-content" }}
                     target="_blank"
                  >
                     <img
                        className="lazy"
                        style={{ marginTop: "15px", maxWidth: "150px" }}
                        loading="lazy"
                        src="./assets/events/vsvc21/sponsors/Israel-Startup-Network-2.png"
                        alt=""
                     />
                  </a>
                  {/* <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/409_409_FreeMind_ws1.jpeg"
                alt=""
              />
            </a> */}
                  <a
                     href="sponsor-link"
                     style={{ height: "fit-content" }}
                     target="_blank"
                  >
                     <img
                        className="lazy"
                        style={{ marginTop: "15px", maxWidth: "150px" }}
                        loading="lazy"
                        src="./assets/events/vsvc21/sponsors/Indiana-Health-Industry-Forum-IHIF.jpeg"
                        alt=""
                     />
                  </a>
                  <a
                     href="sponsor-link"
                     style={{ height: "fit-content" }}
                     target="_blank"
                  >
                     <img
                        className="lazy"
                        style={{ marginTop: "15px", maxWidth: "150px" }}
                        loading="lazy"
                        src="./assets/media/FINTECH MAG.png"
                        alt=""
                     />
                  </a>
                  <a
                     href="sponsor-link"
                     style={{ height: "fit-content" }}
                     target="_blank"
                  >
                     <img
                        className="lazy"
                        style={{ marginTop: "15px", maxWidth: "150px" }}
                        loading="lazy"
                        src="./assets/media/Foresight Canada.png"
                        alt=""
                     />
                  </a>

                  {/* <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/ACTION-e1613498185444-250x130.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Tech-River-Logo.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Austin-Tech-Council-250x97.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Brooks_Keret.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Frenchtech_boston.jpeg"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Fintech-Australia-3.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Clean-Energy-Business-Network-250x130.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/BIusinesss-and-Industry-Association.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Cleantech-Commons-at-Trent-University.jpeg"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Family-Office-Networks.webp"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/FinTEx.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/North-Sacramento-Chamber-of-Commerce.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Oxfordshire-Greentech.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/The-Lab-Miami.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                loading="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                src="./assets/events/vsvc21/sponsors/Times-of-Startups.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Startup-Lithuania.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Harvard-Undergraduate-Capital-Partners-HUCP-1.png"
                alt=""
              />
            </a>
          </div>
          <div className="industry-container-2">
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Mid-Atlantic-Eurasia-Business-Council-logo_1.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/sandbox_logo_h.png"
                alt=""
              />
            </a>
            <a
              href="sponsor-link"
              style={{ height: "fit-content" }}
              loading="lazy"
              target="_blank"
            >
              <img
                className="lazy"
                style={{ marginTop: "15px", maxWidth: "150px" }}
                src="./assets/events/vsvc21/sponsors/XRC-Labs.jpeg"
                alt=""
              />
            </a>
            <a href="sponsor-link" target="_blank">
              <img
                className="lazy"
                height="100px"
                style={{ marginTop: "15px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/ESN-Logo_New.jpeg"
                alt=""
              />
            </a>
            <a href="sponsor-link" target="_blank">
              <img
                className="lazy"
                height="100px"
                style={{ marginTop: "15px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Bioinc-new-logo.png"
                alt=""
              />
            </a>
            <a href="sponsor-link" target="_blank">
              <img
                className="lazy"
                height="100px"
                style={{ marginTop: "15px" }}
                loading="lazy"
                src="./assets/events/vsvc21/sponsors/Venture-Garagelogo.png"
                alt=""
              />
            </a> */}
               </div>
            </div>
         </section>
      </div>
   );
};
